import { toValue, inject } from 'vue'
import { loadScript } from '@/utils/utils'

const gmapsSymbol = Symbol()

export const createGMaps = {
  install: (app, { key } = {}) => {
    const loader = async ({ language = 'en' }) => {
      const src = `https://maps.googleapis.com/maps/api/js?key=${key}&language=${toValue(language)}&libraries=places`
      const script = document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]')

      if (script && script.getAttribute('src') !== src) {
        script.remove()
        delete window.google
      }

      return loadScript(src)
    }

    app.provide(gmapsSymbol, { loader })
  }
}

export function useGMaps () {
  return inject(gmapsSymbol)
}